import React, {Component}from "react";
import Clock from "react-live-clock";
import { observer } from "mobx-react";
import 'moment/locale/ko'

@observer
class NowTimeView extends Component {    
    render() {
        const { rootStore } = this.props;
        return (
            <p className="date">
                <Clock format={'MM월 DD일(dd) HH:mm:ss'} ticking={true} timezone={'Asia/Seoul'}/>
                {/* {rootStore.timerStore.currentTime?.toLocaleDateString() + " " + rootStore.timerStore.currentTime?.toLocaleTimeString()} */}
            </p>
        );
    }
}

export default NowTimeView;
